import React, { useEffect, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { FeaturedShops } from './components/FeaturedShops';
import { HowItWorks } from './components/HowItWorks';
import { TestimonialsSection } from './components/TestimonialsSection';
import { Footer } from './components/Footer';
function setMetaTag(name: string, content: string, property?: boolean) {
  const attr = property ? 'property' : 'name';
  let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
export function App() {
  useEffect(() => {
    // Page Title
    document.title = '新加坡美丽城堡 sgbeautycastle - 新加坡按摩推荐 | 新加坡SPA | 新加坡足浴 | Singapore Massage Guide';
    // Basic SEO Meta Tags
    setMetaTag('description', '新加坡美丽城堡（sgbeautycastle）是新加坡最专业的按摩推荐平台。提供新加坡按摩、新加坡SPA、新加坡足浴、泰式按摩、中式推拿、精油SPA、足部按摩、情侣按摩等全方位服务推荐。覆盖乌节路、牛车水、武吉士、芽笼、丹戎巴葛等新加坡全岛商圈。500+认证商家，50,000+真实好评，新加坡按摩首选平台。');
    setMetaTag('keywords', '新加坡美丽城堡, sgbeautycastle, 新加坡按摩, 新加坡SPA, 新加坡足浴, 新加坡推拿, 新加坡泰式按摩, 新加坡精油按摩, 新加坡足部按摩, 新加坡情侣按摩, 新加坡养生, 新加坡保健按摩, 新加坡正规按摩, 新加坡按摩推荐, 新加坡按摩攻略, 新加坡按摩价格, 乌节路按摩, 牛车水按摩, 武吉士按摩, 芽笼按摩, 丹戎巴葛按摩, 克拉码头按摩, 小印度按摩, Singapore massage, Singapore spa, Thai massage Singapore, foot reflexology Singapore, Chinese Tuina Singapore, aromatherapy Singapore, couples massage Singapore, best massage Singapore');
    setMetaTag('author', '新加坡美丽城堡 sgbeautycastle');
    setMetaTag('robots', 'index, follow');
    setMetaTag('language', 'zh-CN, en');
    // Open Graph (Social Sharing)
    setMetaTag('og:title', '新加坡美丽城堡 sgbeautycastle - 新加坡按摩推荐平台', true);
    setMetaTag('og:description', '新加坡美丽城堡是新加坡领先的专业按摩推荐平台，汇聚500+认证商家，提供泰式按摩、中式推拿、足部按摩、精油SPA等优质服务。50,000+用户信赖之选。', true);
    setMetaTag('og:type', 'website', true);
    setMetaTag('og:url', 'https://www.sgbeautycastle.com', true);
    setMetaTag('og:locale', 'zh_CN', true);
    setMetaTag('og:locale:alternate', 'en_SG', true);
    setMetaTag('og:site_name', '新加坡美丽城堡 sgbeautycastle', true);
    // Twitter Card
    setMetaTag('twitter:card', 'summary_large_image');
    setMetaTag('twitter:title', '新加坡美丽城堡 sgbeautycastle - 新加坡按摩推荐平台');
    setMetaTag('twitter:description', '新加坡美丽城堡，新加坡最专业的按摩推荐平台。500+认证商家，覆盖全岛，泰式按摩、中式推拿、足浴SPA一站式推荐。');
    // Geo Tags for Singapore
    setMetaTag('geo.region', 'SG');
    setMetaTag('geo.placename', 'Singapore');
  }, []);
  return <div className="min-h-screen bg-cream font-sans selection:bg-gold/30 selection:text-forest-dark" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <AboutSection data-id="element-4" />
        <ServicesSection data-id="element-5" />
        <FeaturedShops data-id="element-6" />
        <HowItWorks data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}